import { Control, useWatch } from "react-hook-form";

import EmailBrandingFrame, {
  type EmailBrandingFrameProps
} from "./email-branding-frame.component";

interface EmailBrandingFormFrameProps
  extends Omit<EmailBrandingFrameProps, "body"> {
  // The hosting forms have unrelated value types; only `bodyName` is read.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  control: Control<any>;
  /** The form field holding the classic editor's body. */
  bodyName: string;
}

/**
 * EmailBrandingFrame around an editor bound to a react-hook-form field. The body is watched here,
 * not in the host, so a keystroke re-renders only the frame; the editor element it wraps is the
 * same element and is not re-rendered by it.
 */
export default function EmailBrandingFormFrame({
  control,
  bodyName,
  ...props
}: EmailBrandingFormFrameProps) {
  const body = useWatch({ control, name: bodyName });

  return (
    <EmailBrandingFrame
      {...props}
      body={typeof body === "string" ? body : null}
    />
  );
}
